import { useState, useEffect, useContext } from "react";
import { marginBottom } from "../App";
import { Row, Col } from "react-bootstrap";
import { UserDataContext } from "../components/UserDataContext";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import Founded from "./Founded";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../components/theme";
import { apiRequest } from "../components/Config";

export default function FindUser() {
  const [permissionsAll, setPermissionsAll] = useState([]);
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const { userData } = useContext(UserDataContext);
  const [founded, setFounded] = useState({});

  useEffect(() => {
    if (userData) {
      const fetchData = async () => {
        try {
          const response = await apiRequest("getpossibilities", "GET");
          setPermissionsAll(response);
        } catch (error) {
          console.log(error);
        }
      };
      fetchData();
    }
  }, [userData]);

  useEffect(() => {
    if (userData && selectedPermissions.length > 0) {
      const fetchData = async () => {
        try {
          const response = await apiRequest(
            `findusers/${selectedPermissions}`,
            "GET"
          );
          setFounded(response);
        } catch (error) {
          console.log(error);
        }
      };
      fetchData();
    }
    if (userData && selectedPermissions.length === 0) {
      setFounded([]);
    }
  }, [selectedPermissions]);

  const handleCheckboxChange = (id) => {
    setSelectedPermissions((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((item) => item !== id)
        : [...prevSelected, id]
    );
  };

  return (
    <ThemeProvider theme={theme}>
      <div>
        <Row style={{ marginBottom }}>
          <Col md="3">
            <h4>Wg deklarowanych uprawnień bud.</h4>
          </Col>
          <Col>Lista osób spełniających zaznaczone kryteria</Col>
        </Row>
        <Row style={{ marginBottom }}>
          <Col md="3" style={{ marginBottom }}>
            <FormGroup>
              {permissionsAll.map((permission) => (
                <FormControlLabel
                  key={permission.id}
                  control={
                    <Checkbox
                      checked={selectedPermissions.includes(permission.id)}
                      onChange={() => handleCheckboxChange(permission.id)}
                    />
                  }
                  label={permission.possibility || "Brak opisu"}
                />
              ))}
            </FormGroup>
          </Col>
          <Col md="9" style={{ marginBottom }}>
            {founded && <Founded founded={founded} />}
          </Col>
        </Row>
      </div>
    </ThemeProvider>
  );
}
